import React, { useState } from "react";
import "./Gallary.css";

import img1 from "../img/Image gallery/gallery 1.png";
import img2 from "../img/Image gallery/gallery 2.png";
import img3 from "../img/Image gallery/gallery 3.png";
import img4 from "../img/Image gallery/gallery 4.png";
import img5 from "../img/Image gallery/gallery 5.png";
import img6 from "../img/Image gallery/gallery 6.png";
import img7 from "../img/Image gallery/gallery 7.png";
import img8 from "../img/Image gallery/gallery 8.png";
import img9 from "../img/Image gallery/gallery 9.png";

import cross from "../img/cross.png";

export default function Gallary() {
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);
  const [show7, setShow7] = useState(false);
  const [show8, setShow8] = useState(false);
  const [show9, setShow9] = useState(false);
  
  return (
    <div className="gallary" id="gallery" >
      <h1>Gallery</h1>
      <div className="gallary-grid">
        <img src={img1} alt="gallery-img" onClick={() => setShow1(true)} className='img'/>
        <img src={img2} alt="gallery-img" onClick={() => setShow2(true)}  className='img'/>
        <img src={img3} alt="gallery-img" onClick={() => setShow3(true)}  className='img'/>
        <img src={img4} alt="gallery-img" onClick={() => setShow4(true)}  className='img'/>
        <img src={img5} alt="gallery-img" onClick={() => setShow5(true)}  className='img'/>
        <img src={img6} alt="gallery-img" onClick={() => setShow6(true)}  className='img'/>
        <img src={img7} alt="gallery-img" onClick={() => setShow7(true)}  className='img'/>
        <img src={img8} alt="gallery-img" onClick={() => setShow8(true)}  className='img'/>
        <img src={img9} alt="gallery-img" onClick={() => setShow9(true)} className="last-img img"/>
      </div>

      {/* //////////////////////MAKING OVERLAY OF GALLERY */}
      {show1 && (
        <div className="overlay">
          <img src={img1} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow1(false)}
          />
        </div>
      )}
      {show2 && (
        <div className="overlay">
          <img src={img2} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow2(false)}
          />
        </div>
      )}
      {show3 && (
        <div className="overlay">
          <img src={img3} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow3(false)}
          />
        </div>
      )}
      {show4 && (
        <div className="overlay">
          <img src={img4} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow4(false)}
          />
        </div>
      )}
      {show5 && (
        <div className="overlay">
          <img src={img5} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow5(false)}
          />
        </div>
      )}
      {show6 && (
        <div className="overlay">
          <img src={img6} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow6(false)}
          />
        </div>
      )}
      {show7 && (
        <div className="overlay">
          <img src={img7} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow7(false)}
          />
        </div>
      )}
      {show8 && (
        <div className="overlay">
          <img src={img8} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow8(false)}
          />
        </div>
      )}
      {show9 && (
        <div className="overlay">
          <img src={img9} alt="img" className="img" />
          <img
            src={cross}
            alt="Quit"
            className="cross"
            onClick={() => setShow9(false)}
          />
        </div>
      )}
    </div>
  );
}
